// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__zyy_q","footer":"ModalCreateQualiphyProcedure_footer__1JQXx","additionData":"ModalCreateQualiphyProcedure_additionData__3eEuV"};